const e = "Drücken Sie Tab, um zum Popover zu gehen", t = {
  triggerHint: e
};
export {
  t as default,
  e as triggerHint
};
